import { createElement } from "react";
import React from "react";
import * as react from "react";
import { TaskMsg, useFeliz_UseElmish_React__React_useTaskDispatch_Static } from "../hooks/UseTaskDispatch.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { unwrap, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Entity__get_Name, Entity__get_Id } from "../ClientTypes.fs.js";
import { Modules_MoveToFacility, Modules_UpdateModule, Modules_CreateModule } from "../ServerTypes.fs.js";
import { moveFacility, update as update_1, create as create_2 } from "../Api/Modules.fs.js";
import { Modal_ModalWithBreakdown } from "./Modal.fs.js";
import { stringHash, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { tryHead, length, choose, singleton, cons, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { EntitySelector } from "../components/EntitySelector.fs.js";
import { List_groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";

export function Create(createInputProps) {
    let xs_12, elms_1, elms, elms_3, elms_2, elms_4;
    const close = createInputProps.close;
    const projectId = createInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const detail = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const facilityOpt = patternInput_3[0];
    let create_1;
    const dependencies_1 = [name, detail, facilityOpt];
    create_1 = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, "Create"]));
                const create = new Modules_CreateModule(name, detail, map(Entity__get_Id, facilityOpt));
                taskDispatch(new TaskMsg(2, [taskId]));
                return create_2(projectId, create).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_12 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Detail",
        }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["defaultValue", detail]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        })), (elms_4 = ofArray([createElement("label", {
            className: "label",
            children: "Facility",
        }), createElement(EntitySelector, {
            projectId: projectId,
            entityType: "facility",
            onSelectedEntityChange: patternInput_3[1],
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_4)),
        }))], react.createElement(react.Fragment, {}, ...xs_12)),
        submit: create_1,
        submitText: "Create",
        tasks: patternInput[0],
        title: "Create",
    });
}

export function Update(updateInputProps) {
    let xs_10, elms_1, elms, elms_3, elms_2;
    const close = updateInputProps.close;
    const m = updateInputProps.m;
    const projectId = updateInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(m.Name);
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState(m.Detail);
    const detail = patternInput_2[0];
    let updates;
    const dependencies_1 = [name, detail];
    updates = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, `Update ${name}`]));
                const update = new Modules_UpdateModule(name, detail);
                taskDispatch(new TaskMsg(2, [taskId]));
                return update_1(projectId, m.Id, update).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_10 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Detail",
        }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["defaultValue", detail]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        }))], react.createElement(react.Fragment, {}, ...xs_10)),
        submit: updates,
        submitText: "Update",
        tasks: patternInput[0],
        title: "Update",
    });
}

export function MoveToFacility(moveToFacilityInputProps) {
    let elms;
    const close = moveToFacilityInputProps.close;
    const modules = moveToFacilityInputProps.modules;
    const projectId = moveToFacilityInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const facilityOpt = patternInput_1[0];
    let initialFacility;
    const dependencies_1 = [modules];
    initialFacility = reactApi.useMemo(() => {
        const facilityIds = choose((m) => m.FacilityId, modules);
        if (length(List_groupBy((x) => x, facilityIds, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: stringHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(facilityIds);
        }
    }, dependencies_1);
    let moves;
    const dependencies_1_1 = [facilityOpt];
    moves = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (facilityOpt == null) {
                return Promise.resolve();
            }
            else {
                const facility = facilityOpt;
                const move = new Modules_MoveToFacility(Entity__get_Id(facility));
                return PromiseBuilder__For_1565554B(promise, modules, (_arg) => {
                    const m_1 = _arg;
                    taskDispatch(new TaskMsg(0, [m_1.Id, `Move ${m_1.Name} To Facility : ${Entity__get_Name(facility)}`]));
                    taskDispatch(new TaskMsg(2, [m_1.Id]));
                    return moveFacility(projectId, m_1.Id, move).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [m_1.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [m_1.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Facility",
        }), createElement(EntitySelector, {
            projectId: projectId,
            entityType: "facility",
            initialEntity: unwrap(initialFacility),
            onSelectedEntityChange: patternInput_1[1],
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: moves,
        submitText: "Move",
        tasks: patternInput[0],
        title: "Move To Facility",
    });
}

